import React from 'react';
import { FaSpinner } from 'react-icons/fa';

function Loader({ progress, text }) {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex items-center justify-center z-50">
      <div className="flex flex-col items-center bg-customeBlack p-5 rounded-xl">
        <img
          className="h-64"
          src={require('../../images/logo.gif')}
          alt="Minerva Analytics"
        />
        <FaSpinner className="animate-spin text-gray-500 mt-4" size={30} />
        {progress !== undefined && 
        <>
          <div className="w-5/6 bg-gray-200 h-2 rounded-lg mt-5">
            <div
              className="bg-customeOrange h-full rounded-lg transition-all duration-300"
              style={{ width: `${progress}%` }}
            ></div>
          </div>
          <span className="text-gray-500 mt-2">{progress}%</span>
          </>
        }
        {text !== undefined && <span className='text-gray-500 mt-5 animate-flash'>{text ? text : 'Analyzing...'}</span>}
      </div>
    </div>
  );
}

export default Loader;
